import { BillingFrequency, ProductKey, Tier, TierPrice } from 'generated/types'

const formattedFrequencies = {
  [BillingFrequency.Monthly]: 'month',
}

export const formatTierPrice = (preferredTierPrice: TierPrice): string => {
  const tierPriceValue = preferredTierPrice.amount.value
  const tierPriceFrequency = formattedFrequencies[preferredTierPrice.billingFrequency]

  return `$${tierPriceValue}/${tierPriceFrequency}`
}

export const hasProductInTier = (productKey: ProductKey, tier: Tier): boolean => {
  return !!tier.products.find(product => product.key === productKey)
}
